import React from "react"

type RatingLabelPropsType = {
  children?: React.ReactNode
}

function RatingLabel({ children }: RatingLabelPropsType) {
  return <div className="cobalt-rating__label">{children}</div>
}

export default RatingLabel
